import {
  SeasonalRuleDetail,
  SeasonalRulePayload,
} from 'models/seasonality/SeasonalRule';
import API from 'services/API';

export interface CreateOrUpdateSeasonalRuleArgs {
  uid?: string;
  payload: SeasonalRulePayload;
}

export const createOrUpdateSeasonalRule = async ({
  uid,
  payload,
}: CreateOrUpdateSeasonalRuleArgs): Promise<SeasonalRuleDetail> => {
  const url = uid
    ? `api/internal/seasonal-rules/cancellation-policies/${uid}`
    : 'api/internal/seasonal-rules/cancellation-policies';
  const response = uid
    ? await API.put<SeasonalRuleDetail>(url, payload)
    : await API.post<SeasonalRuleDetail>(url, payload);
  return response.data;
};
